import types from "resources/types";
import { createResourceListQuery } from "queries";

export const reviewRequestsQuery = (config = {}) =>
  createResourceListQuery(types.REVIEW_REQUESTS, {
    url: "/api/v2/review_requests/?limit=99",
    ...config,
  });
